import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { getItemTree } from "@/common/utils/listItemTree";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import { SortType } from "@reflag/shared/featureAPI";
import {
  FlagHeaderCollectionQueryInput,
  FlagHeaderDTO,
} from "@reflag/shared/flagAPI";

type UseFlagsParams = FlagHeaderCollectionQueryInput & {
  sortType?: SortType;
};

export type FlagWithSubRows = FlagHeaderDTO & {
  subRows?: FlagWithSubRows[];
};

export function useFlags(params?: UseFlagsParams, enabled = true) {
  const { appId } = useEnvironment();
  const { sortType, ...apiParams } = params ?? {};

  return useQuery({
    queryKey: featureQueryKeys.flags(appId, params),
    queryFn: () =>
      api
        .get<"/apps/:appId/flags">(`/apps/${appId}/flags`, {
          params: { ...apiParams, appId },
        })
        .then((res) => res.data || { data: [] }),
    enabled: !!appId && enabled,
    placeholderData: keepPreviousData,
    select(response) {
      const data = response.data ?? [];
      return {
        ...response,
        data:
          sortType === "hierarchical"
            ? getItemTree(data, "parentFlagId")
            : data,
        metadata: {
          sortType: sortType ?? "flat",
          viewId: undefined,
        },
      };
    },
  });
}
